import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '#F4777C',
      offset: '4px',
    },
  },
});

export default {
  preset: MyPreset,
  options: {
    darkModeSelector: '.ukravto-dark',
  },
  directives: {
    include: ['Tooltip'],
  },
};
